<div class="plate">
  <div class="plate__right flipped-text">
    <span>K</span>
    <span>S</span>
    <span>A</span>
    <mat-icon>arrow_drop_up</mat-icon>
  </div>
  <ng-container *ngIf="parsedPlateNumber?.plateNumberDigitsAR">
    <div class="plate__left-top">{{parsedPlateNumber?.plateNumberDigitsAR}}</div>
    <div class="plate__middle-top">
      <span dir="rtl">{{parsedPlateNumber?.rightCharAR}} {{parsedPlateNumber?.middleCharAR}} {{parsedPlateNumber?.leftCharAR}}</span>
    </div>
    <div class="plate__left-bottom">{{parsedPlateNumber?.plateNumberDigits}}</div>
    <div class="plate__middle-bottom">{{parsedPlateNumber?.leftCharEN}} {{parsedPlateNumber?.middleCharEN}} {{parsedPlateNumber?.rightCharEN}}</div>
  </ng-container>
  <ng-container *ngIf="!parsedPlateNumber?.plateNumberDigitsAR">
    <ng-container *ngIf="isExternal">
      <div class="plate__left-top">{{plateNumber || "___"}}</div>
      <div class="plate__left-bottom">{{ "sharedFeatures.PlateNumber.External" | translate }}</div>
    </ng-container>
    <ng-container *ngIf="!isExternal">
      <div class="p-4">{{plateNumber || "___"}}</div>
    </ng-container>
  </ng-container>
</div>
